export default __webpack_public_path__ + "dso_internship_report.pdf";